import { wrapLazyRoute } from "../lazy-loading/lazyWrapper";
import FeatureSessionStore from "../uidispatcherapi/FeatureSessionStore";
import { CI_BLOCK_OLD_TERMS_AND_CONDITIONS_PAGE } from "../../api/Features";
export const routes = () => {
	const appRoutes: any[] = [
		{
			path: "/catalogue",
			component: wrapLazyRoute(() => import("cia_ui/CataloguePage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				trackingName: "Promotions:eCatOverview",
				visibleForAnonymous: true,
			},
		},
		{
			path: "/storelist",
			childRoutes: [
				{
					path: "/storelist/:ListId",
					component: wrapLazyRoute(
						() =>
							import("cia_ui/StoreListPageWrappers").then(m => ({
								default: m.StoreListPageWrapper,
							})),
						{
							usesBootstrap: true,
						},
					),
					routeParam: {
						trackingName: "metroList",
						visibleForAnonymous: true,
					},
				},
			],
		},
		{
			path: "/metrolist",
			childRoutes: [
				{
					path: "/metrolist/:ListId",
					component: wrapLazyRoute(
						() =>
							import("cia_ui/StoreListPageWrappers").then(m => ({
								default: m.StoreListMCRMPageWrapper,
							})),
						{
							usesBootstrap: true,
						},
					),
					routeParam: {
						trackingName: "metroList",
						visibleForAnonymous: true,
					},
				},
			],
		},
		{
			path: "/exlogin",
			component: wrapLazyRoute(() => import("cia_ui/LoginPage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				trackingName: "login",
				noCustomerNeed: true,
				publicVisible: true,
			},
			childRoutes: [
				{
					path: "/exlogin/*",
					routeParam: {
						trackingName: "login",
						noCustomerNeed: true,
						publicVisible: true,
					},
				},
			],
		},
		{
			path: "/faq",
			component: wrapLazyRoute(() => import("cia_ui/FAQPage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				trackingName: "faq",
				noCustomerNeed: true,
				visibleForAnonymous: true,
			},
		},
	];
	const termsAndConditionToggle = FeatureSessionStore.getMembershipFor(CI_BLOCK_OLD_TERMS_AND_CONDITIONS_PAGE);

	if (termsAndConditionToggle === "A") {
		appRoutes.push(
			{
				path: "/public/impress",
				component: wrapLazyRoute(() => import("cia_ui/LegalNoticePage"), {
					usesBootstrap: true,
				}),
				routeParam: {
					trackingName: "imprint",
					noCustomerNeed: true,
				},
			},
			{
				path: "/public/datapolicy",
				component: wrapLazyRoute(() => import("cia_ui/PrivacyStatementPage"), {
					usesBootstrap: true,
				}),
				routeParam: {
					trackingName: "datapolicy",
					noCustomerNeed: true,
				},
			},
			{
				path: "/public/terms",
				component: wrapLazyRoute(() => import("cia_ui/TermsPage"), {
					usesBootstrap: true,
				}),
				routeParam: {
					trackingName: "terms",
					noCustomerNeed: true,
				},
			},
		);
	}

	return appRoutes;
};
